module.exports = __webpack_public_path__ + "img/blue_025.f5bed7f3.png";